/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FavoriteDTO,
  FavoriteItem,
} from '../models/index';
import {
    FavoriteDTOFromJSON,
    FavoriteDTOToJSON,
    FavoriteItemFromJSON,
    FavoriteItemToJSON,
} from '../models/index';

export interface ApiFavoriteDeleteRequest {
    contentfulId: string;
}

export interface ApiFavoritePostRequest {
    favoriteItem: FavoriteItem;
}

/**
 * 
 */
export class FavoriteApi extends runtime.BaseAPI {

    /**
     */
    async apiFavoriteDeleteRaw(requestParameters: ApiFavoriteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contentfulId'] == null) {
            throw new runtime.RequiredError(
                'contentfulId',
                'Required parameter "contentfulId" was null or undefined when calling apiFavoriteDelete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contentfulId'] != null) {
            queryParameters['contentfulId'] = requestParameters['contentfulId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/favorite`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiFavoriteDelete(requestParameters: ApiFavoriteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiFavoriteDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiFavoriteGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FavoriteDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/favorite`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FavoriteDTOFromJSON));
    }

    /**
     */
    async apiFavoriteGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FavoriteDTO>> {
        const response = await this.apiFavoriteGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFavoritePostRaw(requestParameters: ApiFavoritePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['favoriteItem'] == null) {
            throw new runtime.RequiredError(
                'favoriteItem',
                'Required parameter "favoriteItem" was null or undefined when calling apiFavoritePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/favorite`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FavoriteItemToJSON(requestParameters['favoriteItem']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiFavoritePost(requestParameters: ApiFavoritePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiFavoritePostRaw(requestParameters, initOverrides);
    }

}
